<script>

export default {
  name: 'indexClass',
  data() {
    return {
      username: localStorage.getItem('name'),
      loading: true,
      tableData: [],
      optionProps: {
        expandTrigger: 'hover',
        title: "name",
        label: "name",
        value: "id",
        children: "children",
      },
      dialogVisible: false,
      indexClass_post: {
        id: "",
        name: "",
        img: "",
      },
      classSort: [],
      choice: []
    }
  },
  mounted() {
    this.getIndexClass()
    this.getClassSort()
  },
  methods: {
    getClassSort() {
      this.$axios.get("/admin/stock/classSort").then((res) => {
        this.classSort = res.data.data
      })
    },
    // 获取数据
    getIndexClass() {
      this.loading = true
      this.$axios.get("/admin/indexClass").then((res) => {
        this.loading = false
        this.tableData = res.data.data
      })
    },
    setIndexClass() {
      if (this.indexClass_post.id == "") {
        this.$confirm('请选择分类', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      if (this.indexClass_post.img == "") {
        this.$confirm('请上传图片', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.$axios.post("/admin/indexClass", this.indexClass_post).then((res) => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "首页分类管理",
          "name": this.username,
          "content": "添加了'" + this.indexClass_post.name + "'的首页分类"
        })
        this.getIndexClass()
        this.close()
        this.$message.success("添加成功")
      }).catch((r) => {
        this.$message.error("添加失败")
      })
    },
    close() {
      this.dialogVisible = false
      this.indexClass_post.id = ""
      this.indexClass_post.img = ""
      this.indexClass_post.name = ""
    },
    deleteIndexClass(e) {
      this.$confirm('此操作将永久删除' + e.name + '的首页分类展示, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete("/admin/indexClass/" + e.id).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "首页分类管理",
            "name": this.username,
            "content": "删除了'" + e.name + "'的首页分类展示"
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getIndexClass()
        }).catch((r) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    out() {
      this.$router.push({name: 'login'})
    },
    error() {
      this.$message.error("上传失败")
      this.$alert('请上传图片类型文件，或图片过大，图片最大为1MB，请使用画图工具将图片尺寸调小至1000像素以内', '上传失败', {
        confirmButtonText: '确定',
      });
    },
    success(response, file, fileList, row) {
      this.indexClass_post.img = response
    },
    selectClass() {
      this.indexClass_post.id = this.indexClass_post.id[this.indexClass_post.id.length - 1]
    },
    handleSelectionChange(v) {
      this.choice = v
    },
    batchDeleteIndexClass() {
      let name = ''
      this.choice.forEach(e => {
        name += e.name + '，'
      })
      this.$confirm('此操作将永久删除' + name + '的首页分类展示, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.choice.forEach(e => {
          id += e.id + '_'
        })
        id = id.substring(0, id.length - 1)
        this.$axios.delete("/admin/indexClass/batch/" + id).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "首页分类管理",
            "name": this.username,
            "content": "删除了'" + name + "'的首页分类展示"
          })
          this.getIndexClass()
          this.$message.success("删除成功")
        }).catch((error) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>首页分类管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      <el-button class="topInput" type="primary" @click="dialogVisible=true">添加分类</el-button>
      <el-button class="topInput" type="danger" @click="batchDeleteIndexClass">批量删除</el-button>
    </el-header>
    <el-main class="el-main">
      <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          highlight-current-row
          current-row-key="id"
          @selection-change="handleSelectionChange"
          max-height="500">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" width="300"></el-table-column>
        <el-table-column prop="img" align="center" label="图片"
                         width="500">
          <template slot-scope="scope">
            <div>
              <el-image
                  scroll-container="#listTable .el-table__body-wrapper"
                  fit="contain"
                  :src="'/image/'+scope.row.img"
                  style="width: 70px; height: 70px;margin-right: 20px;">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="deleteIndexClass(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog title="添加分类" :visible.sync="dialogVisible" @close="close">
      <el-form :model="indexClass_post" :inline="true">
        <el-form-item label="分类名称">
          <el-cascader
              v-model="indexClass_post.id" placeholder="请选择"
              :options="classSort"
              :props="optionProps"
              @change="selectClass"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
              class="avatar-uploader"
              action="/admin/img"
              :on-error="error"
              :show-file-list="false"
              :on-success="success">
            <img v-if="indexClass_post.img" :src="'/image/'+indexClass_post.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="setIndexClass()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-top: 10px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 25px;
}

.avatar-uploader .el-upload {
  border: 1px solid #000;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

input[aria-hidden="true"] {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none;
}

</style>



// WEBPACK FOOTER //
// src/views/indexClassView.vue